import BookviewTabPanelFooter from "organisms/panels/bookview-tab-panels/bookview-tab-panel-footer";
import CollapsePanel from "molecules/collapse-panel/collapse-panel";
import EmailMultiInput from "molecules/form-fields/email-multi-input";
import Form from "molecules/forms/form";
import Loader from "atoms/loaders/loader";
import React, { useEffect, useState } from "react";
import ShareSpacePanelAtom from "utilities/atoms/bookview/share-space-panel-atom";
import ShareSpaceSubmitButton from "atoms/buttons/share-space-submit-button";
import StringUtils from "utilities/string-utils";
import TextAreaFormField from "molecules/form-fields/text-area-form-field";
import useBreakpointRanges from "utilities/hooks/use-breakpoint-ranges";
import useDebounce from "utilities/hooks/use-debounce";
import { IconSizes } from "atoms/constants/icon-sizes";
import { t } from "utilities/localization-utils";
import { useAtom } from "jotai";

interface ShareSpacePanelEmailFooterProps {
    handleFormSubmit: () => void;
    validationErrors: string;
    loading: boolean;
}

const BASE_CLASS_NAME = "c-share-space-panel-email-footer";

const ShareSpacePanelEmailFooter = ({
    handleFormSubmit,
    validationErrors,
    loading,
}: ShareSpacePanelEmailFooterProps) => {
    const [sharePanelAtom, setSharePanelAtom] = useAtom(ShareSpacePanelAtom);
    const [message, setMessage] = useState(sharePanelAtom.message);
    const { inMobileView } = useBreakpointRanges();
    const debouncedMessage = useDebounce(message);

    const handleMessageChanged = (
        e: React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        setMessage(e.target.value);
    };

    const handleEmailAddressesChanged = (newValues: Array<string>) => {
        setSharePanelAtom(sharePanelAtom.with({ emails: newValues }));
    };

    useEffect(() => {
        if (debouncedMessage !== sharePanelAtom.message) {
            setSharePanelAtom(
                sharePanelAtom.with({
                    message: debouncedMessage,
                })
            );
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedMessage]);

    const PanelTop = () => {
        return (
            <header className={`${BASE_CLASS_NAME}__panelTop`}>
                {t("shareWith")}
            </header>
        );
    };
    return (
        <>
            <CollapsePanel
                iconSize={IconSizes.Base}
                modifierCSSClassName={BASE_CLASS_NAME}
                buttonAriaText={""}
                collapse={false}
                panelTop={<PanelTop />}>
                <section className={`${BASE_CLASS_NAME}__body`}>
                    {loading ? (
                        <Loader />
                    ) : (
                        <Form name={t("share")}>
                            <EmailMultiInput
                                emails={sharePanelAtom.emails}
                                errorMessages={[validationErrors]}
                                inModal={true}
                                isValid={StringUtils.isEmpty(validationErrors)}
                                label={t("emailAddresses")}
                                onEmailsChanged={handleEmailAddressesChanged}
                                required={true}
                                suggestTeamMembers={true}
                            />
                            <TextAreaFormField
                                isValid={true}
                                label={t("message")}
                                onChange={handleMessageChanged}
                                placeholder={`${t("enterAMessage")} ${t(
                                    "field-optional"
                                )}`}
                                value={message}
                                rows={inMobileView ? 1 : 2}
                            />
                        </Form>
                    )}
                </section>
            </CollapsePanel>
            {!inMobileView && (
                <BookviewTabPanelFooter>
                    <ShareSpaceSubmitButton onClick={handleFormSubmit} />
                </BookviewTabPanelFooter>
            )}
        </>
    );
};

export default ShareSpacePanelEmailFooter;
